// Labels are resolved at call time so they follow the active language; the
// `value` of each entry is the API keyword and must never be translated.
const getCategories = (t) => [
    { value: "gym", label: t("manageContent.categories.options.gym") },
    { value: "nutrition", label: t("manageContent.categories.options.nutrition") },
    { value: "yoga", label: t("manageContent.categories.options.yoga") },
    { value: "pilates", label: t("manageContent.categories.options.pilates") },
    { value: "crossfit", label: t("manageContent.categories.options.crossfit") },
    { value: "running", label: t("manageContent.categories.options.running") },
    { value: "cycling", label: t("manageContent.categories.options.cycling") },
    { value: "mindset", label: t("manageContent.categories.options.mindset") },
    { value: "psicology", label: t("manageContent.categories.options.psicology") },
    { value: "suplements", label: t("manageContent.categories.options.suplements") },
    { value: "home_workout", label: t("manageContent.categories.options.homeWorkout") },
    { value: "swimming", label: t("manageContent.categories.options.swimming") },
    { value: "climbing", label: t("manageContent.categories.options.climbing") },
    { value: "soccer", label: t("manageContent.categories.options.soccer") },
    { value: "basketball", label: t("manageContent.categories.options.basketball") },
    { value: "tennis", label: t("manageContent.categories.options.tennis") },
    { value: "golf", label: t("manageContent.categories.options.golf") },
    { value: "baseball", label: t("manageContent.categories.options.baseball") },
    { value: "rugby", label: t("manageContent.categories.options.rugby") },
    { value: "hockey", label: t("manageContent.categories.options.hockey") },
    { value: "volleyball", label: t("manageContent.categories.options.volleyball") },
    { value: "softball", label: t("manageContent.categories.options.softball") },
    { value: "gymnastics", label: t("manageContent.categories.options.gymnastics") },
    { value: "cheerleading", label: t("manageContent.categories.options.cheerleading") },
    { value: "lacrosse", label: t("manageContent.categories.options.lacrosse") },
    { value: "triathlon", label: t("manageContent.categories.options.triathlon") }
];

export default getCategories;
